module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disk-index disk-app"
  }, [_c('div', {
    staticClass: "disk-body"
  }, [_c('aside', {
    staticClass: "disk-side"
  }, [_c('div', {
    staticClass: "disk-brand"
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.folder,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("网盘")])]), _vm._v(" "), _c('div', {
    staticClass: "disk-nav"
  }, [_vm._l((_vm.mainSpaces), function(sp) {
    return _c('div', {
      key: sp.key,
      class: ['disk-space-item', {
        on: _vm.activeSpace && _vm.activeSpace.key === sp.key
      }],
      on: {
        "click": function($event) {
          return _vm.enterSpace(sp)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": _vm.spaceIcon(sp),
        "size": "18"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.spaceLabel(sp)))])], 1)
  }), _vm._v(" "), _c('div', {
    class: ['disk-space-item', {
      on: _vm.inRecycle
    }],
    on: {
      "click": function($event) {
        _vm.enterSpace(_vm.recycleSpace())
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-trash-outline",
      "size": "18"
    }
  }), _vm._v(" "), _c('span', [_vm._v("回收站")])], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-space-item",
    on: {
      "click": function($event) {
        return _vm.$router.push('/disk/shares')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-share-alt",
      "size": "18"
    }
  }), _vm._v(" "), _c('span', [_vm._v("分享记录")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "disk-side-section"
  }, [_c('div', {
    staticClass: "disk-side-title"
  }, [_c('span', [_vm._v("我的群")]), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "新建群",
      "placement": "top",
      "transfer": ""
    }
  }, [_c('a', {
    staticClass: "disk-side-add",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openCreateGroup.apply(null, arguments)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-plus-empty",
      "size": "20"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-group-search"
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "搜索群",
      "icon": "ios-search"
    },
    model: {
      value: (_vm.groupKeyword),
      callback: function($$v) {
        _vm.groupKeyword = $$v
      },
      expression: "groupKeyword"
    }
  })], 1), _vm._v(" "), (!_vm.groupSpaces.length) ? _c('div', {
    staticClass: "disk-side-empty"
  }, [_vm._v("还没有加入任何群")]) : (!_vm.filteredGroupSpaces.length) ? _c('div', {
    staticClass: "disk-side-empty"
  }, [_vm._v("没有匹配的群")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disk-group-list"
  }, _vm._l((_vm.filteredGroupSpaces), function(sp) {
    return _c('div', {
      key: sp.key,
      class: ['disk-space-item', 'disk-group-item', {
        on: _vm.activeSpace && _vm.activeSpace.key === sp.key
      }],
      on: {
        "click": function($event) {
          return _vm.enterSpace(sp)
        }
      }
    }, [_c('span', {
      staticClass: "disk-avatar disk-avatar-sm",
      style: ({
        background: _vm.avatarColor(sp.node.name)
      })
    }, [_vm._v(_vm._s(_vm.avatarText(sp.node.name)))]), _vm._v(" "), _c('span', {
      staticClass: "disk-group-item-name",
      attrs: {
        "title": sp.node.name
      }
    }, [_vm._v(_vm._s(sp.node.name))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "disk-main"
  }, [_c('div', {
    staticClass: "disk-topbar"
  }, [_c('div', {
    staticClass: "disk-path"
  }, [_c('a', {
    class: ['disk-path-back', {
      disabled: _vm.breadcrumb.length < 2
    }],
    attrs: {
      "title": "返回上一级"
    },
    on: {
      "click": _vm.goUp
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-left",
      "size": "18"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.breadcrumb), function(item, index) {
    return [(index > 0) ? _c('Icon', {
      key: 'sep-' + item.id + '-' + index,
      staticClass: "disk-path-sep",
      attrs: {
        "type": "ios-arrow-right"
      }
    }) : _vm._e(), _vm._v(" "), (index === 0 && _vm.inGroupSpace && _vm.activeGroup) ? _c('span', {
      key: 'p-' + item.id + '-' + index,
      class: ['disk-path-group', {
        current: _vm.breadcrumb.length === 1
      }],
      on: {
        "click": function($event) {
          _vm.breadcrumb.length > 1 && _vm.jumpTo(0)
        }
      }
    }, [_c('span', {
      staticClass: "disk-avatar disk-avatar-xs",
      style: ({
        background: _vm.avatarColor(_vm.activeGroup.name)
      })
    }, [_vm._v(_vm._s(_vm.avatarText(_vm.activeGroup.name)))]), _vm._v(" "), _c('span', {
      staticClass: "disk-path-group-name",
      attrs: {
        "title": _vm.activeGroup.name
      }
    }, [_vm._v(_vm._s(_vm.activeGroup.name))]), _vm._v(" "), _c('span', {
      class: ['disk-role-tag', 'role-' + (_vm.activeGroup.myRole || 3)]
    }, [_vm._v(_vm._s(_vm.roleText(_vm.activeGroup.myRole)))])]) : (index < _vm.breadcrumb.length - 1) ? _c('a', {
      key: 'p-' + item.id + '-' + index,
      staticClass: "disk-path-item",
      on: {
        "click": function($event) {
          return _vm.jumpTo(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', {
      key: 'p-' + item.id + '-' + index,
      staticClass: "disk-path-item current"
    }, [_vm._v(_vm._s(item.name))])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "disk-topbar-right"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.inRecycle),
      expression: "!inRecycle"
    }],
    staticClass: "disk-search"
  }, [_c('Input', {
    attrs: {
      "placeholder": "搜索当前目录及子目录",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-enter": _vm.search,
      "on-click": _vm.search
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1), _vm._v(" "), (_vm.inGroupSpace && _vm.activeGroup) ? [_c('Tooltip', {
    attrs: {
      "content": _vm.isGroupManager ? '成员管理' : '群成员',
      "placement": "bottom",
      "transfer": ""
    }
  }, [_c('a', {
    class: ['disk-members', {
      readonly: !_vm.isGroupManager
    }],
    on: {
      "click": function($event) {
        _vm.isGroupManager && _vm.openMemberManage()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-people-outline",
      "size": "20"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activeGroup.memberCount || 0))])], 1)]), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "群动态",
      "placement": "bottom",
      "transfer": ""
    }
  }, [_c('a', {
    staticClass: "disk-icon-btn",
    on: {
      "click": _vm.openActivityPanel
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-pulse",
      "size": "20"
    }
  })], 1)]), _vm._v(" "), (_vm.isGroupOwner || !_vm.isGroupManager) ? _c('Dropdown', {
    attrs: {
      "trigger": "click",
      "placement": "bottom-end",
      "transfer": ""
    },
    on: {
      "on-click": _vm.onGroupSetting
    }
  }, [_c('a', {
    staticClass: "disk-icon-btn",
    attrs: {
      "title": "更多"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "more",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [(_vm.isGroupOwner) ? [_c('DropdownItem', {
    attrs: {
      "name": "rename"
    }
  }, [_vm._v("修改群名")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "transfer"
    }
  }, [_vm._v("转让群主")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "dissolve",
      "divided": ""
    }
  }, [_c('span', {
    staticClass: "disk-text-danger"
  }, [_vm._v("解散群")])])] : _c('DropdownItem', {
    attrs: {
      "name": "leave"
    }
  }, [_c('span', {
    staticClass: "disk-text-danger"
  }, [_vm._v("退出群")])])], 2)], 1) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), (_vm.inGroupSpace && _vm.activeGroup && Number(_vm.activeGroup.id) === 1) ? _c('disk-group-nav', {
    attrs: {
      "group-id": _vm.activeGroup.id,
      "root-node-id": _vm.activeGroup.rootNodeId || (_vm.activeSpace && _vm.activeSpace.node && _vm.activeSpace.node.id),
      "current-folder-id": _vm.currentFolder && _vm.currentFolder.id
    },
    on: {
      "open-target": _vm.onNavOpenTarget
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disk-toolbar"
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  }), _vm._v(" "), _c('input', {
    ref: "folderInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "",
      "webkitdirectory": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  }), _vm._v(" "), (!_vm.inRecycle && _vm.selectedRows.length) ? [_c('div', {
    staticClass: "disk-batch"
  }, [_c('span', {
    staticClass: "disk-batch-count"
  }, [_vm._v("已选 "), _c('b', [_vm._v(_vm._s(_vm.selectedRows.length))]), _vm._v(" 项")]), _vm._v(" "), (_vm.canDownload) ? _c('Button', {
    attrs: {
      "icon": "ios-download-outline"
    },
    on: {
      "click": _vm.downloadSelected
    }
  }, [_vm._v("下载")]) : _vm._e(), _vm._v(" "), (_vm.canShare) ? _c('Button', {
    attrs: {
      "icon": "android-share-alt"
    },
    on: {
      "click": function($event) {
        return _vm.openShare()
      }
    }
  }, [_vm._v("分享")]) : _vm._e(), _vm._v(" "), (_vm.canMove) ? _c('Button', {
    attrs: {
      "icon": "ios-redo-outline"
    },
    on: {
      "click": _vm.openMoveSelected
    }
  }, [_vm._v("移动")]) : _vm._e(), _vm._v(" "), (_vm.canAcl) ? _c('Button', {
    attrs: {
      "icon": "ios-locked-outline"
    },
    on: {
      "click": function($event) {
        return _vm.openAcl()
      }
    }
  }, [_vm._v("授权")]) : _vm._e(), _vm._v(" "), (_vm.canDelete) ? _c('Button', {
    staticClass: "disk-btn-danger",
    attrs: {
      "icon": "ios-trash-outline"
    },
    on: {
      "click": _vm.deleteSelected
    }
  }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "disk-batch-clear",
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("取消选择")])], 1)] : (!_vm.inRecycle) ? [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-cloud-upload-outline",
      "disabled": !_vm.canUpload
    },
    on: {
      "click": _vm.chooseUpload
    }
  }, [_vm._v("上传")]), _vm._v(" "), _c('Button', {
    attrs: {
      "icon": "ios-plus-empty",
      "disabled": !_vm.canUpload
    },
    on: {
      "click": _vm.openMkdir
    }
  }, [_vm._v("新建文件夹")])] : _c('div', {
    staticClass: "disk-recycle-note"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-outline"
    }
  }), _vm._v("\n          删除的文件会保留在这里，可随时恢复\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-count"
  }, [_vm._v(_vm._s(_vm.listKeyword ? '搜索结果 ' : '共 ') + _vm._s(_vm.list.length) + " 项")])], 2), _vm._v(" "), _c('Table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading || _vm.list.length),
      expression: "loading || list.length"
    }],
    ref: "fileTable",
    staticClass: "disk-file-table",
    attrs: {
      "highlight-row": "",
      "columns": _vm.displayColumns,
      "data": _vm.list,
      "loading": _vm.loading,
      "row-class-name": _vm.fileRowClass
    },
    on: {
      "on-selection-change": _vm.onSelectionChange,
      "on-current-change": _vm.onCurrentChange
    }
  }), _vm._v(" "), (!_vm.loading && !_vm.list.length) ? _c('div', {
    staticClass: "disk-empty"
  }, [_c('img', {
    staticClass: "disk-empty-icon",
    attrs: {
      "src": _vm.inRecycle ? _vm.icons.file : _vm.icons.folder,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-empty-title"
  }, [_vm._v(_vm._s(_vm.emptyTitle))]), _vm._v(" "), (!_vm.inRecycle && !_vm.listKeyword && _vm.canUpload) ? _c('div', {
    staticClass: "disk-empty-sub"
  }, [_vm._v("把文件上传到这里，团队成员就能一起查看")]) : _vm._e(), _vm._v(" "), (!_vm.inRecycle && !_vm.listKeyword && _vm.canUpload) ? _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-cloud-upload-outline"
    },
    on: {
      "click": _vm.chooseUpload
    }
  }, [_vm._v("上传文件")]) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": "新建文件夹",
      "width": "440",
      "mask-closable": false
    },
    model: {
      value: (_vm.showMkdirModal),
      callback: function($$v) {
        _vm.showMkdirModal = $$v
      },
      expression: "showMkdirModal"
    }
  }, [_c('div', {
    staticClass: "disk-dm-field"
  }, [_c('img', {
    staticClass: "disk-dm-field-icon",
    attrs: {
      "src": _vm.icons.folder,
      "alt": ""
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入文件夹名称",
      "maxlength": 255
    },
    on: {
      "on-enter": _vm.onMkdir
    },
    model: {
      value: (_vm.mkdirName),
      callback: function($$v) {
        _vm.mkdirName = $$v
      },
      expression: "mkdirName"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showMkdirModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.mkdirLoading
    },
    on: {
      "click": _vm.onMkdir
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": "重命名",
      "width": "440",
      "mask-closable": false
    },
    model: {
      value: (_vm.showRenameModal),
      callback: function($$v) {
        _vm.showRenameModal = $$v
      },
      expression: "showRenameModal"
    }
  }, [_c('div', {
    staticClass: "disk-dm-field"
  }, [(_vm.renameNode) ? _c('img', {
    staticClass: "disk-dm-field-icon",
    attrs: {
      "src": _vm.fileIcon(_vm.renameNode),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入新名称",
      "maxlength": 255
    },
    on: {
      "on-enter": _vm.onRename
    },
    model: {
      value: (_vm.renameName),
      callback: function($$v) {
        _vm.renameName = $$v
      },
      expression: "renameName"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showRenameModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.renameLoading
    },
    on: {
      "click": _vm.onRename
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": _vm.pickerMode === 'copy' ? '复制到' : '移动到',
      "width": "560",
      "mask-closable": false
    },
    model: {
      value: (_vm.showMoveModal),
      callback: function($$v) {
        _vm.showMoveModal = $$v
      },
      expression: "showMoveModal"
    }
  }, [_c('div', {
    staticClass: "disk-dm-target"
  }, [(_vm.moveNodes.length === 1) ? _c('img', {
    attrs: {
      "src": _vm.fileIcon(_vm.moveNodes[0]),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.icons.file,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.moveTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "disk-dm-tabs"
  }, _vm._l((_vm.moveSpaces), function(sp) {
    return _c('a', {
      key: sp.key,
      class: ['disk-dm-tab', {
        on: _vm.moveCrumbs.length && _vm.moveCrumbs[0].id === sp.node.id
      }],
      on: {
        "click": function($event) {
          return _vm.switchMoveSpace(sp)
        }
      }
    }, [_vm._v(_vm._s(sp.node.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "disk-picker"
  }, [_c('div', {
    staticClass: "disk-picker-path"
  }, [_vm._l((_vm.moveCrumbs), function(item, index) {
    return [(index > 0) ? _c('Icon', {
      key: 'ms-' + item.id + '-' + index,
      staticClass: "disk-path-sep",
      attrs: {
        "type": "ios-arrow-right"
      }
    }) : _vm._e(), _vm._v(" "), (index < _vm.moveCrumbs.length - 1) ? _c('a', {
      key: 'mp-' + item.id + '-' + index,
      on: {
        "click": function($event) {
          return _vm.jumpMove(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', {
      key: 'mp-' + item.id + '-' + index,
      staticClass: "current"
    }, [_vm._v(_vm._s(item.name))])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "disk-picker-body"
  }, [(_vm.moveFolderLoading) ? _c('div', {
    staticClass: "disk-picker-empty"
  }, [_c('Spin')], 1) : (!_vm.moveFolders.length) ? _c('div', {
    staticClass: "disk-picker-empty"
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.folder,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.pickerMode === 'copy' ? '这里没有子文件夹，可以直接复制到此处' : '这里没有子文件夹，可以直接移动到此处'))])]) : _vm._l((_vm.moveFolders), function(folder) {
    return _c('div', {
      key: folder.id,
      staticClass: "disk-move-folder",
      on: {
        "click": function($event) {
          return _vm.enterMoveFolder(folder)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.icons.folder,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(folder.name))]), _vm._v(" "), _c('Icon', {
      staticClass: "disk-move-folder-arrow",
      attrs: {
        "type": "ios-arrow-right"
      }
    })], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showMoveModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.moveSaving,
      "disabled": _vm.moveHereDisabled
    },
    on: {
      "click": _vm.confirmMove
    }
  }, [_vm._v(_vm._s(_vm.pickerMode === 'copy' ? '复制到此处' : '移动到此处'))])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": _vm.previewName,
      "width": "960"
    },
    on: {
      "on-visible-change": _vm.onPreviewVisible
    },
    model: {
      value: (_vm.showPreviewModal),
      callback: function($$v) {
        _vm.showPreviewModal = $$v
      },
      expression: "showPreviewModal"
    }
  }, [_c('div', {
    staticClass: "disk-preview",
    class: {
      'disk-preview-center': _vm.centerPreview
    }
  }, [(_vm.previewLoading) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("加载中...")]) : (_vm.previewError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v(_vm._s(_vm.previewError))]) : (_vm.previewType === 'image') ? _c('img', {
    staticClass: "disk-preview-image",
    attrs: {
      "src": _vm.previewUrl
    }
  }) : (_vm.previewType === 'pdf') ? _c('iframe', {
    staticClass: "disk-preview-frame",
    attrs: {
      "src": _vm.previewBlobUrl
    }
  }) : (_vm.previewType === 'video') ? [_c('video', {
    ref: "previewVideo",
    staticClass: "disk-preview-media",
    attrs: {
      "src": _vm.previewUrl,
      "controls": ""
    },
    on: {
      "error": _vm.onMediaError
    }
  }), _vm._v(" "), (_vm.mediaError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")]) : _vm._e()] : (_vm.previewType === 'audio') ? [_c('audio', {
    ref: "previewAudio",
    attrs: {
      "src": _vm.previewUrl,
      "controls": ""
    },
    on: {
      "error": _vm.onMediaError
    }
  }), _vm._v(" "), (_vm.mediaError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")]) : _vm._e()] : (_vm.previewType === 'office' && _vm.previewEngine === 'aliyun') ? [_c('div', {
    ref: "aliyunOffice",
    staticClass: "disk-preview-frame"
  })] : (_vm.previewType === 'office') ? [_c('iframe', {
    staticClass: "disk-preview-frame",
    attrs: {
      "src": _vm.officeUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-preview-hint"
  }, [_vm._v("若无法打开，请下载后查看")])] : (_vm.previewType === 'csv') ? [(_vm.previewEmpty) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("没有可预览的内容")]) : _c('div', {
    staticClass: "disk-preview-table-wrap"
  }, [_c('table', {
    staticClass: "disk-preview-table"
  }, [_c('tbody', _vm._l((_vm.previewRows), function(line, lineIndex) {
    return _c('tr', {
      key: lineIndex
    }, _vm._l((line), function(cell, cellIndex) {
      return _c('td', {
        key: cellIndex,
        class: {
          'disk-preview-th': lineIndex === 0
        }
      }, [_vm._v(_vm._s(cell))])
    }), 0)
  }), 0)])])] : (_vm.previewType === 'markdown') ? _c('div', {
    staticClass: "disk-preview-markdown",
    domProps: {
      "innerHTML": _vm._s(_vm.previewHtml)
    }
  }) : (_vm.previewType === 'json') ? [(_vm.jsonError) ? _c('div', {
    staticClass: "disk-preview-hint"
  }, [_vm._v("不是合法 JSON")]) : _vm._e(), _vm._v(" "), _c('pre', {
    staticClass: "disk-preview-pre"
  }, [_vm._v(_vm._s(_vm.previewText))])] : (_vm.previewType === 'text') ? _c('pre', {
    staticClass: "disk-preview-pre"
  }, [_vm._v(_vm._s(_vm.previewText))]) : _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-download"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.previewDownloadId)
      }
    }
  }, [_vm._v("下载")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": "授权",
      "width": "760"
    },
    model: {
      value: (_vm.showAclModal),
      callback: function($$v) {
        _vm.showAclModal = $$v
      },
      expression: "showAclModal"
    }
  }, [_c('div', {
    staticClass: "disk-dm-target"
  }, [(_vm.aclNodes.length === 1) ? _c('img', {
    attrs: {
      "src": _vm.fileIcon(_vm.aclNodes[0]),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.icons.file,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.aclTitle
    }
  }, [_vm._v(_vm._s(_vm.aclTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "disk-dm-card"
  }, [_c('div', {
    staticClass: "disk-dm-card-title"
  }, [_vm._v("添加授权")]), _vm._v(" "), _c('div', {
    staticClass: "disk-acl-form"
  }, [_c('RadioGroup', {
    attrs: {
      "type": "button"
    },
    on: {
      "on-change": _vm.onSubjectTypeChange
    },
    model: {
      value: (_vm.aclForm.subjectType),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "subjectType", $$v)
      },
      expression: "aclForm.subjectType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("员工")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("权限组")])], 1), _vm._v(" "), (_vm.aclForm.subjectType === 1) ? [_c('Select', {
    key: 'acl-users-' + _vm.adminUserSelectKey,
    staticClass: "disk-acl-select",
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminUserLoading,
      "disabled": _vm.adminUserLoading,
      "placeholder": "搜索并选择员工"
    },
    model: {
      value: (_vm.aclForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "subjectIds", $$v)
      },
      expression: "aclForm.subjectIds"
    }
  }, _vm._l((_vm.aclAdminUsers), function(user) {
    return _c('Option', {
      key: user.id,
      attrs: {
        "value": user.id,
        "label": _vm.userLabel(user)
      }
    }, [_vm._v("\n              " + _vm._s(_vm.userLabel(user)) + "\n            ")])
  }), 1), _vm._v(" "), _c('a', {
    staticClass: "disk-acl-all",
    class: {
      disabled: _vm.adminUserLoading || !_vm.aclAdminUsers.length
    },
    on: {
      "click": function($event) {
        !(_vm.adminUserLoading || !_vm.aclAdminUsers.length) && _vm.selectAllUsers()
      }
    }
  }, [_vm._v("全选员工")])] : [_c('Select', {
    key: 'acl-groups-' + _vm.adminGroupSelectKey,
    staticClass: "disk-acl-select",
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminGroupLoading,
      "disabled": _vm.adminGroupLoading,
      "placeholder": "搜索并选择权限组"
    },
    model: {
      value: (_vm.aclForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "subjectIds", $$v)
      },
      expression: "aclForm.subjectIds"
    }
  }, _vm._l((_vm.adminGroups), function(group) {
    return _c('Option', {
      key: group.id,
      attrs: {
        "value": group.id,
        "label": group.title
      }
    }, [_vm._v(_vm._s(group.title))])
  }), 1), _vm._v(" "), _c('a', {
    staticClass: "disk-acl-all",
    class: {
      disabled: _vm.adminGroupLoading || !_vm.adminGroups.length
    },
    on: {
      "click": function($event) {
        !(_vm.adminGroupLoading || !_vm.adminGroups.length) && _vm.selectAllGroups()
      }
    }
  }, [_vm._v("全选权限组")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "disk-acl-perm"
  }, [_c('span', {
    staticClass: "disk-acl-perm-label"
  }, [_vm._v("可以")]), _vm._v(" "), _c('CheckboxGroup', {
    staticClass: "disk-chip-checks",
    model: {
      value: (_vm.aclForm.permBits),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "permBits", $$v)
      },
      expression: "aclForm.permBits"
    }
  }, _vm._l((_vm.permOptions), function(item) {
    return _c('Checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1), _vm._v(" "), _c('Button', {
    staticClass: "disk-acl-save",
    attrs: {
      "type": "primary",
      "loading": _vm.aclSaving
    },
    on: {
      "click": _vm.saveAcl
    }
  }, [_vm._v("保存授权")])], 1)]), _vm._v(" "), (_vm.aclNodes.length <= 1) ? [_c('div', {
    staticClass: "disk-dm-section-title"
  }, [_vm._v("已授权 "), _c('span', [_vm._v(_vm._s(_vm.aclList.length))])]), _vm._v(" "), _c('div', {
    staticClass: "disk-person-list"
  }, [(_vm.aclLoading) ? _c('div', {
    staticClass: "disk-picker-empty"
  }, [_c('Spin')], 1) : (!_vm.aclList.length) ? _c('div', {
    staticClass: "disk-person-empty"
  }, [_vm._v("还没有授权给任何人")]) : _vm._e(), _vm._v(" "), _vm._l(((_vm.aclLoading ? [] : _vm.aclList)), function(item) {
    return _c('div', {
      key: item.id || (item.subjectType + '-' + item.subjectId),
      staticClass: "disk-person"
    }, [_c('span', {
      staticClass: "disk-avatar disk-avatar-md",
      style: ({
        background: _vm.avatarColor(_vm.aclSubjectName(item))
      })
    }, [_vm._v(_vm._s(_vm.avatarText(_vm.aclSubjectName(item))))]), _vm._v(" "), _c('div', {
      staticClass: "disk-person-main"
    }, [_c('div', {
      staticClass: "disk-person-name"
    }, [_vm._v("\n              " + _vm._s(_vm.aclSubjectName(item)) + "\n              "), _c('span', {
      staticClass: "disk-mini-tag"
    }, [_vm._v(_vm._s(item.subjectType === 2 ? '权限组' : '员工'))])]), _vm._v(" "), _c('div', {
      staticClass: "disk-person-sub"
    }, [_vm._v(_vm._s(_vm.permText(item.perm)))])]), _vm._v(" "), _c('a', {
      staticClass: "disk-link-danger",
      on: {
        "click": function($event) {
          return _vm.removeAcl(item)
        }
      }
    }, [_vm._v("移除")])])
  })], 2)] : _c('div', {
    staticClass: "disk-tip"
  }, [_vm._v("保存后，同样的授权会写到每一个选中项。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showAclModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 2), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": "分享文件",
      "width": "720"
    },
    model: {
      value: (_vm.showShareModal),
      callback: function($$v) {
        _vm.showShareModal = $$v
      },
      expression: "showShareModal"
    }
  }, [_c('div', {
    staticClass: "disk-dm-target"
  }, [(_vm.shareNodes.length === 1) ? _c('img', {
    attrs: {
      "src": _vm.fileIcon(_vm.shareNodes[0]),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.icons.file,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.shareTitle
    }
  }, [_vm._v(_vm._s(_vm.shareTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "disk-dm-card"
  }, [_c('div', {
    staticClass: "disk-share-row"
  }, [_c('span', {
    staticClass: "disk-share-label"
  }, [_vm._v("有效期")]), _vm._v(" "), _c('RadioGroup', {
    attrs: {
      "type": "button"
    },
    model: {
      value: (_vm.shareForm.expireType),
      callback: function($$v) {
        _vm.$set(_vm.shareForm, "expireType", $$v)
      },
      expression: "shareForm.expireType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("1天")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "7"
    }
  }, [_vm._v("7天")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "30"
    }
  }, [_vm._v("30天")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "forever"
    }
  }, [_vm._v("永久")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v("自定义")])], 1)], 1), _vm._v(" "), (_vm.shareForm.expireType === 'custom') ? _c('div', {
    staticClass: "disk-share-row"
  }, [_c('span', {
    staticClass: "disk-share-label"
  }, [_vm._v("到期时间")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm:ss",
      "placeholder": "请选择到期时间",
      "transfer": "",
      "value": _vm.shareForm.customExpireDate
    },
    on: {
      "on-change": _vm.onCustomExpire
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disk-share-row"
  }, [_c('span', {
    staticClass: "disk-share-label"
  }, [_vm._v("提取码")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "maxlength": 4,
      "placeholder": "不填则无需提取码"
    },
    model: {
      value: (_vm.shareForm.extractCode),
      callback: function($$v) {
        _vm.$set(_vm.shareForm, "extractCode", $$v)
      },
      expression: "shareForm.extractCode"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "disk-share-random",
    on: {
      "click": _vm.randomExtractCode
    }
  }, [_vm._v("随机生成")])], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-share-row disk-share-submit"
  }, [_c('span', {
    staticClass: "disk-share-label"
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "link",
      "loading": _vm.shareSaving
    },
    on: {
      "click": _vm.createShare
    }
  }, [_vm._v("创建链接并复制")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "disk-dm-section-title"
  }, [_vm._v("分享链接 "), _c('span', [_vm._v(_vm._s(_vm.shareList.length))])]), _vm._v(" "), _c('div', {
    staticClass: "disk-share-list"
  }, [(!_vm.shareList.length) ? _c('div', {
    staticClass: "disk-person-empty"
  }, [_vm._v("还没有分享链接")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shareList), function(item) {
    return _c('div', {
      key: item.id || item.token,
      staticClass: "disk-share-item"
    }, [_c('div', {
      staticClass: "disk-share-item-top"
    }, [_c('Icon', {
      staticClass: "disk-share-item-icon",
      attrs: {
        "type": "link"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "disk-share-url",
      attrs: {
        "href": _vm.buildShareUrl(item.token, item.extractCode),
        "target": "_blank",
        "rel": "noopener",
        "title": _vm.buildShareUrl(item.token, item.extractCode)
      }
    }, [_vm._v(_vm._s(_vm.buildShareUrl(item.token, item.extractCode)))]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "type": "primary",
        "ghost": ""
      },
      on: {
        "click": function($event) {
          _vm.copyText(_vm.buildShareUrl(item.token, item.extractCode))
        }
      }
    }, [_vm._v("复制")])], 1), _vm._v(" "), _c('div', {
      staticClass: "disk-share-item-meta"
    }, [(_vm.shareNodes.length > 1) ? _c('span', [_vm._v(_vm._s(item.nodeName))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("提取码 "), _c('b', [_vm._v(_vm._s(item.extractCode || '无'))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.expireTime ? _vm.formatTime(item.expireTime) + ' 到期' : '永久有效'))]), _vm._v(" "), (item.creatorName) ? _c('span', [_vm._v(_vm._s(item.creatorName) + " 分享")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("访问 " + _vm._s(item.visitCount || 0) + " · 预览 " + _vm._s(item.previewCount || 0) + " · 下载 " + _vm._s(item.downloadCount || 0))]), _vm._v(" "), _c('span', {
      staticClass: "disk-share-item-ops"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.openShareLog(item)
        }
      }
    }, [_vm._v("访问记录")]), _vm._v(" "), _c('a', {
      staticClass: "disk-link-danger",
      on: {
        "click": function($event) {
          return _vm.revokeShare(item)
        }
      }
    }, [_vm._v("撤销")])])])])
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showShareModal = false
      }
    }
  }, [_vm._v("完成")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": "访问记录",
      "width": "720"
    },
    model: {
      value: (_vm.showShareLogModal),
      callback: function($$v) {
        _vm.showShareLogModal = $$v
      },
      expression: "showShareLogModal"
    }
  }, [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.shareLogColumns,
      "data": _vm.shareLogList,
      "loading": _vm.shareLogLoading,
      "no-data-text": "还没有预览或下载"
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": "上传文件",
      "width": "860",
      "mask-closable": false
    },
    model: {
      value: (_vm.showUploadModal),
      callback: function($$v) {
        _vm.showUploadModal = $$v
      },
      expression: "showUploadModal"
    }
  }, [_c('div', {
    staticClass: "disk-upload-head"
  }, [_c('div', {
    staticClass: "disk-dm-target"
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.folder,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("上传到：" + _vm._s(_vm.currentFolder ? _vm.currentFolder.name : '当前目录'))])]), _vm._v(" "), _c('div', {
    staticClass: "disk-upload-switch"
  }, [_c('span', [_vm._v("同名文件覆盖")]), _vm._v(" "), _c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.overwriteSame),
      callback: function($$v) {
        _vm.overwriteSame = $$v
      },
      expression: "overwriteSame"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "disk-drop",
    on: {
      "dragover": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.onDropFiles.apply(null, arguments)
      }
    }
  }, [_c('Icon', {
    staticClass: "disk-drop-icon",
    attrs: {
      "type": "ios-cloud-upload-outline",
      "size": "56"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "disk-drop-title"
  }, [_vm._v("把文件或文件夹拖到这里")]), _vm._v(" "), _c('p', {
    staticClass: "disk-drop-sub"
  }, [_vm._v("或者")]), _vm._v(" "), _c('div', [_c('Button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "icon": "ios-paper-outline"
    },
    on: {
      "click": _vm.pickFiles
    }
  }, [_vm._v("选择文件")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "ghost": "",
      "icon": "ios-folder-outline"
    },
    on: {
      "click": _vm.pickFolder
    }
  }, [_vm._v("选择文件夹")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-upload-rules"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.uploadRulesOpen = !_vm.uploadRulesOpen
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-outline"
    }
  }), _vm._v("\n        上传须知\n        "), _c('Icon', {
    attrs: {
      "type": _vm.uploadRulesOpen ? 'ios-arrow-up' : 'ios-arrow-down'
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadRulesOpen),
      expression: "uploadRulesOpen"
    }],
    staticClass: "disk-upload-rules-body"
  }, [_c('p', [_vm._v("文件命名规范：1.使用 UTF-8 编码 2.区分大小写 3.长度必须在 1~1023 字节之间 4. 不能以 / 或者 \\ 字符开头")]), _vm._v(" "), _c('p', [_vm._v("文件上传提示：待上传列表最多允许添加 10000 个文件，超出部分被丢弃，如果要完整上传，请将文件打包成 Zip 包，上传后解压。")]), _vm._v(" "), _c('p', [_vm._v("扫描只加入待上传列表，不会上传。点下方「上传文件」后才开始。同名是否覆盖默认关闭。关闭时同名文件会另存为「主名.1.0.后缀」，已有 1.x 则次版本加 1。打开后原文件会被彻底删除，不进回收站，再用同名上传新文件。同名文件夹仍直接使用。")])])]), _vm._v(" "), (_vm.scanning) ? _c('p', {
    staticClass: "disk-tip"
  }, [_vm._v("正在扫描，已读取 " + _vm._s(_vm.scanCount) + " 个文件…")]) : _vm._e(), _vm._v(" "), (_vm.uploadTotal) ? _c('Table', {
    staticClass: "disk-upload-table",
    attrs: {
      "columns": _vm.uploadColumns,
      "data": _vm.uploadPageRows,
      "no-data-text": "没有文件或文件夹"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.uploadTotal) ? _c('div', {
    staticClass: "disk-upload-page"
  }, [_c('span', [_vm._v("共 " + _vm._s(_vm.uploadTotal) + " 个")]), _vm._v(" "), _c('Page', {
    attrs: {
      "total": _vm.uploadTotal,
      "page-size": _vm.uploadPageSize,
      "current": _vm.uploadPage,
      "size": "small"
    },
    on: {
      "on-change": _vm.onUploadPage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.canBeginUpload,
      "loading": _vm.uploading
    },
    on: {
      "click": _vm.beginUpload
    }
  }, [_vm._v("上传文件")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        _vm.showUploadModal = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), (_vm.activityPanelOpen) ? _c('div', {
    staticClass: "disk-activity-drawer"
  }, [_c('div', {
    staticClass: "disk-activity-head"
  }, [_c('span', [_vm._v("群动态")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.activityPanelOpen = false
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), (_vm.activityLoading && !_vm.activityGroups.length) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("加载中…")]) : (!_vm.activityGroups.length) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("暂无群动态")]) : _c('div', {
    staticClass: "disk-activity-body",
    on: {
      "scroll": _vm.onActivityScroll
    }
  }, [_vm._l((_vm.activityGroups), function(g) {
    return _c('div', {
      key: g.day,
      staticClass: "disk-activity-day"
    }, [_c('div', {
      staticClass: "disk-activity-day-label"
    }, [_vm._v(_vm._s(g.label))]), _vm._v(" "), _vm._l((g.items), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "disk-activity-card"
      }, [_c('div', {
        staticClass: "disk-activity-dot"
      }), _vm._v(" "), _c('div', {
        staticClass: "disk-activity-card-main"
      }, [_c('div', {
        staticClass: "disk-activity-card-top"
      }, [_c('strong', [_vm._v(_vm._s(item.actorName || '成员'))]), _vm._v(" "), _c('span', {
        staticClass: "disk-activity-time"
      }, [_vm._v(_vm._s(_vm.formatActivityTime(item.gmtCreate)))])]), _vm._v(" "), (_vm.activityLinkable(item)) ? _c('div', {
        staticClass: "disk-activity-summary"
      }, [_vm._l((_vm.activitySummaryParts(item)), function(part, pi) {
        return [(part.link) ? _c('a', {
          key: pi,
          staticClass: "disk-activity-link",
          on: {
            "click": function($event) {
              return _vm.locateActivity(item)
            }
          }
        }, [_vm._v(_vm._s(part.text))]) : _c('span', {
          key: pi
        }, [_vm._v(_vm._s(part.text))])]
      })], 2) : _c('div', {
        staticClass: "disk-activity-summary"
      }, [_vm._v(_vm._s(item.summary))])])])
    })], 2)
  }), _vm._v(" "), (_vm.activityLoading) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("加载中…")]) : (_vm.activityNoMore && _vm.activityList.length) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("没有更多了")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disk-task-float",
    class: {
      open: _vm.taskPanelOpen
    }
  }, [(_vm.taskPanelOpen) ? _c('div', {
    staticClass: "disk-task-panel"
  }, [_c('div', {
    staticClass: "disk-task-head"
  }, [_c('span', [_vm._v("任务列表")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.taskPanelOpen = false
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), (_vm.showTaskOverall) ? _c('div', {
    staticClass: "disk-task-overall"
  }, [_c('Progress', {
    attrs: {
      "percent": _vm.taskOverallPercent,
      "stroke-width": 8
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-task-overall-text"
  }, [_vm._v("\n          已传 " + _vm._s(_vm.formatSize(_vm.taskOverallDone)) + " / 共 " + _vm._s(_vm.formatSize(_vm.taskOverallTotal)) + "（" + _vm._s(_vm.taskOverallPercent) + "%）\n          "), _c('span', {
    staticClass: "disk-task-speed"
  }, [_vm._v(_vm._s(_vm.formatSpeed(_vm.taskSpeedBps)))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disk-task-note"
  }, [_vm._v("刷新或关闭浏览器会取消当前上传任务，并清除全部记录。")]), _vm._v(" "), _c('div', {
    staticClass: "disk-task-filters"
  }, _vm._l((_vm.taskTabs), function(tab) {
    return _c('a', {
      key: tab.key,
      class: {
        on: _vm.taskFilter === tab.key
      },
      on: {
        "click": function($event) {
          _vm.taskFilter = tab.key
        }
      }
    }, [_vm._v(_vm._s(tab.label) + "(" + _vm._s(tab.count) + ")")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "disk-task-tools"
  }, [_c('span', {
    staticClass: "disk-task-concurrency"
  }, [_vm._v("\n          并发：智能\n          "), (_vm.uploadAutoHint) ? _c('span', {
    staticClass: "disk-upload-auto-hint"
  }, [_vm._v(_vm._s(_vm.uploadAutoHint))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "disk-task-tool-btns"
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.taskUploadingCount
    },
    on: {
      "click": _vm.stopUploads
    }
  }, [_vm._v("停止上传")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "small",
      "disabled": !_vm.taskResumableCount || _vm.uploading
    },
    on: {
      "click": _vm.startAllUploads
    }
  }, [_vm._v("全部开始")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "small",
      "disabled": !_vm.taskRemovableCount
    },
    on: {
      "click": _vm.clearAllTasks
    }
  }, [_vm._v("全部移除")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.taskView.length) ? _c('div', {
    staticClass: "disk-task-empty"
  }, [_vm._v("暂无上传任务")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.taskView), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "disk-task-row"
    }, [_c('div', [_c('div', {
      staticClass: "disk-task-name",
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "disk-task-size"
    }, [_vm._v(_vm._s(_vm.formatSize(item.size)))]), _vm._v(" "), (_vm.taskFilter === 'uploading' && item.state === 'uploading') ? _c('Progress', {
      attrs: {
        "percent": item.percent,
        "stroke-width": 6
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "disk-task-dest",
      attrs: {
        "title": item.dest
      }
    }, [_vm._v(_vm._s(item.dest || '/'))]), _vm._v(" "), _c('div', {
      class: ['disk-task-state', item.state],
      attrs: {
        "title": item.failMsg || item.stateLabel
      }
    }, [_vm._v(_vm._s(item.stateLabel))]), _vm._v(" "), _c('div', {
      staticClass: "disk-task-ops"
    }, [(item.state === 'uploading') ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.pauseUpload(item)
        }
      }
    }, [_vm._v("暂停")]) : _vm._e(), _vm._v(" "), (item.state === 'stopped' || item.state === 'failed') ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.continueUpload(item)
        }
      }
    }, [_vm._v("继续上传")]) : _vm._e(), _vm._v(" "), (item.state === 'stopped' || item.state === 'failed' || item.state === 'success') ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.clearTask(item)
        }
      }
    }, [_vm._v("移除")]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['disk-task-bar', {
      uploading: _vm.taskBarUploading
    }],
    on: {
      "click": function($event) {
        _vm.taskPanelOpen = !_vm.taskPanelOpen
      }
    }
  }, [(_vm.taskBarUploading) ? [_c('span', {
    staticClass: "disk-wave"
  }, [_c('span', {
    staticClass: "disk-wave-fill back",
    style: ({
      top: _vm.taskWaveTop
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "disk-wave-fill",
    style: ({
      top: _vm.taskWaveTop
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "disk-task-progress"
  }, [_c('span', {
    staticClass: "disk-task-progress-main"
  }, [_vm._v("上传中 " + _vm._s(_vm.taskOverallPercent) + "%")]), _vm._v(" "), _c('span', {
    staticClass: "disk-task-progress-speed"
  }, [_vm._v(_vm._s(_vm.formatSpeed(_vm.taskSpeedBps)))])])] : [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload"
    }
  }), _vm._v(" "), _c('span', [_vm._v("任务列表")])], _vm._v(" "), (_vm.taskBadge) ? _c('span', {
    staticClass: "disk-task-badge"
  }, [_vm._v(_vm._s(_vm.taskBadge))]) : _vm._e(), _vm._v(" "), _c('Icon', {
    staticClass: "disk-task-bar-arrow",
    attrs: {
      "type": _vm.taskPanelOpen ? 'ios-arrow-down' : 'ios-arrow-up'
    }
  })], 2)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "width": "440",
      "mask-closable": false,
      "closable": !_vm.purgeLoading
    },
    model: {
      value: (_vm.showPurgeModal),
      callback: function($$v) {
        _vm.showPurgeModal = $$v
      },
      expression: "showPurgeModal"
    }
  }, [_c('div', {
    staticClass: "disk-purge"
  }, [_c('div', {
    staticClass: "disk-purge-icon"
  }, [_c('Icon', {
    attrs: {
      "type": "alert-circled",
      "size": "28"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-purge-main"
  }, [_c('div', {
    staticClass: "disk-purge-title"
  }, [_vm._v("永久删除，不可恢复")]), _vm._v(" "), (_vm.purgeNode) ? _c('div', {
    staticClass: "disk-purge-target"
  }, [_c('img', {
    attrs: {
      "src": _vm.fileIcon(_vm.purgeNode),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.purgeNode.name
    }
  }, [_vm._v(_vm._s(_vm.purgeNode.name))])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "disk-purge-list"
  }, [_c('li', [_vm._v("将同时删除云端存储的文件，删除后无法从回收站恢复，也无法下载")]), _vm._v(" "), (_vm.purgeNode && _vm.purgeNode.nodeType === 1) ? _c('li', [_vm._v("这是文件夹，里面的所有文件和子文件夹会一起被永久删除")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("相关的授权记录会一并清除")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "disabled": _vm.purgeLoading
    },
    on: {
      "click": function($event) {
        _vm.showPurgeModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "loading": _vm.purgeLoading
    },
    on: {
      "click": _vm.confirmPurge
    }
  }, [_vm._v("彻底删除")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": "新建群",
      "width": "440",
      "mask-closable": false
    },
    model: {
      value: (_vm.showCreateGroupModal),
      callback: function($$v) {
        _vm.showCreateGroupModal = $$v
      },
      expression: "showCreateGroupModal"
    }
  }, [_c('div', {
    staticClass: "disk-dm-field"
  }, [_c('span', {
    staticClass: "disk-avatar disk-avatar-md",
    style: ({
      background: _vm.avatarColor(_vm.createGroupName)
    })
  }, [_vm._v(_vm._s(_vm.avatarText(_vm.createGroupName)))]), _vm._v(" "), _c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "给群起个名字",
      "maxlength": 64
    },
    on: {
      "on-enter": _vm.onCreateGroup
    },
    model: {
      value: (_vm.createGroupName),
      callback: function($$v) {
        _vm.createGroupName = $$v
      },
      expression: "createGroupName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-dm-hint"
  }, [_vm._v("建群后可以邀请同事，一起上传和管理群文件")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showCreateGroupModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.createGroupLoading
    },
    on: {
      "click": _vm.onCreateGroup
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": "成员管理",
      "width": "860",
      "mask-closable": false
    },
    model: {
      value: (_vm.showMemberModal),
      callback: function($$v) {
        _vm.showMemberModal = $$v
      },
      expression: "showMemberModal"
    }
  }, [(_vm.activeGroup) ? _c('div', {
    staticClass: "disk-member-head"
  }, [_c('span', {
    staticClass: "disk-avatar disk-avatar-md",
    style: ({
      background: _vm.avatarColor(_vm.activeGroup.name)
    })
  }, [_vm._v(_vm._s(_vm.avatarText(_vm.activeGroup.name)))]), _vm._v(" "), _c('div', {
    staticClass: "disk-member-head-main"
  }, [_c('div', {
    staticClass: "disk-person-name"
  }, [_vm._v(_vm._s(_vm.activeGroup.name))]), _vm._v(" "), _c('div', {
    staticClass: "disk-person-sub"
  }, [_vm._v(_vm._s(_vm.memberList.length) + " 条成员记录")])]), _vm._v(" "), (_vm.isGroupOwner) ? _c('Dropdown', {
    attrs: {
      "trigger": "click",
      "placement": "bottom-end",
      "transfer": ""
    },
    on: {
      "on-click": _vm.onGroupSetting
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-gear-outline"
    }
  }, [_vm._v("群设置")]), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "rename"
    }
  }, [_vm._v("修改群名")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "transfer"
    }
  }, [_vm._v("转让群主")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "dissolve",
      "divided": ""
    }
  }, [_c('span', {
    staticClass: "disk-text-danger"
  }, [_vm._v("解散群")])])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activeGroup) ? _c('div', {
    staticClass: "disk-dm-card disk-member-toolbar"
  }, [_c('RadioGroup', {
    attrs: {
      "type": "button"
    },
    on: {
      "on-change": function($event) {
        _vm.memberForm.subjectIds = []
      }
    },
    model: {
      value: (_vm.memberForm.subjectType),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "subjectType", $$v)
      },
      expression: "memberForm.subjectType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("员工")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("账号组")])], 1), _vm._v(" "), (_vm.memberForm.subjectType === 1) ? _c('Select', {
    staticClass: "disk-member-select",
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminUserLoading,
      "placeholder": "搜索并选择要邀请的员工"
    },
    model: {
      value: (_vm.memberForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "subjectIds", $$v)
      },
      expression: "memberForm.subjectIds"
    }
  }, _vm._l((_vm.adminUsers), function(user) {
    return _c('Option', {
      key: 'mu-' + user.id,
      attrs: {
        "value": user.id,
        "label": _vm.userLabel(user)
      }
    }, [_vm._v("\n          " + _vm._s(_vm.userLabel(user)) + "\n        ")])
  }), 1) : _c('Select', {
    staticClass: "disk-member-select",
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminGroupLoading,
      "placeholder": "搜索并选择账号组"
    },
    model: {
      value: (_vm.memberForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "subjectIds", $$v)
      },
      expression: "memberForm.subjectIds"
    }
  }, _vm._l((_vm.adminGroups), function(group) {
    return _c('Option', {
      key: 'mg-' + group.id,
      attrs: {
        "value": group.id,
        "label": group.title
      }
    }, [_vm._v("\n          " + _vm._s(group.title) + "\n        ")])
  }), 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-personadd-outline",
      "loading": _vm.memberSaving
    },
    on: {
      "click": _vm.addGroupMembers
    }
  }, [_vm._v("邀请")])], 1) : _vm._e(), _vm._v(" "), _c('Table', {
    staticClass: "disk-member-table",
    attrs: {
      "columns": _vm.memberColumns,
      "data": _vm.memberList,
      "loading": _vm.memberLoading
    },
    on: {
      "on-expand": _vm.onMemberExpand
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showMemberModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": "修改群名",
      "width": "440",
      "mask-closable": false
    },
    model: {
      value: (_vm.showRenameGroupModal),
      callback: function($$v) {
        _vm.showRenameGroupModal = $$v
      },
      expression: "showRenameGroupModal"
    }
  }, [_c('div', {
    staticClass: "disk-dm-field"
  }, [_c('span', {
    staticClass: "disk-avatar disk-avatar-md",
    style: ({
      background: _vm.avatarColor(_vm.renameGroupName)
    })
  }, [_vm._v(_vm._s(_vm.avatarText(_vm.renameGroupName)))]), _vm._v(" "), _c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入新群名称",
      "maxlength": 64
    },
    on: {
      "on-enter": _vm.onRenameGroup
    },
    model: {
      value: (_vm.renameGroupName),
      callback: function($$v) {
        _vm.renameGroupName = $$v
      },
      expression: "renameGroupName"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showRenameGroupModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.renameGroupLoading
    },
    on: {
      "click": _vm.onRenameGroup
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": "转让群主",
      "width": "440",
      "mask-closable": false
    },
    model: {
      value: (_vm.showTransferModal),
      callback: function($$v) {
        _vm.showTransferModal = $$v
      },
      expression: "showTransferModal"
    }
  }, [_c('div', {
    staticClass: "disk-dm-hint disk-dm-hint-top"
  }, [_vm._v("转让后你将变为普通成员，新群主拥有全部管理权限")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "large",
      "filterable": "",
      "transfer": "",
      "placeholder": "选择新群主（须已是群成员）"
    },
    model: {
      value: (_vm.transferOwnerId),
      callback: function($$v) {
        _vm.transferOwnerId = $$v
      },
      expression: "transferOwnerId"
    }
  }, _vm._l((_vm.personMembers), function(m) {
    return _c('Option', {
      key: 'tr-' + m.subjectId,
      attrs: {
        "value": m.subjectId,
        "label": m.subjectName
      }
    }, [_vm._v("\n        " + _vm._s(m.subjectName) + "（" + _vm._s(_vm.roleText(m.role)) + "）\n      ")])
  }), 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showTransferModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.transferLoading
    },
    on: {
      "click": _vm.onTransferGroup
    }
  }, [_vm._v("确定转让")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disk-task-cols"
  }, [_c('span', [_vm._v("文件")]), _vm._v(" "), _c('span', [_vm._v("上传到")]), _vm._v(" "), _c('span', [_vm._v("状态")]), _vm._v(" "), _c('span', [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4426c574","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/disk/DiskIndex.vue
// module id = 1784
// module chunks = 8